function SupportIcon() {
	return (
		<svg
			width="81"
			height="81"
			viewBox="0 0 81 81"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M47.0889 1.20971C58.9437 4.01539 59.6788 20.4264 66.3573 30.6148C70.7348 37.2929 77.6643 42.01 78.9947 49.8833C80.584 59.2884 81.2491 70.569 74.1934 76.9877C67.2284 83.3239 56.4397 80.0133 47.0889 78.9086C39.2758 77.9855 32.3963 75.4094 25.712 71.2601C15.9424 65.1955 2.4456 61.1861 0.330918 49.8833C-1.8913 38.0056 7.50086 27.3807 15.8721 18.6665C24.4582 9.72865 35.0283 -1.64468 47.0889 1.20971Z"
				fill="#2874EF"
			/>
			<g clipPath="url(#clip0_390_58137)">
				<mask
					id="mask0_390_58137"
					style={{ maskType: "luminance" }}
					maskUnits="userSpaceOnUse"
					x="17"
					y="20"
					width="46"
					height="46"
				>
					<path
						d="M17.0017 20.6367H62.0017V65.6367H17.0017V20.6367Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask0_390_58137)">
					<path
						d="M41.3757 54.0794L43.8318 56.5355C45.0085 57.7121 46.9162 57.7121 48.0929 56.5355C49.2695 55.3589 49.2695 53.4511 48.0929 52.2744L45.6238 49.8053"
						stroke="white"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M40.0488 30.9333L36.8947 27.7794C32.6481 23.5327 25.763 23.5327 21.5163 27.7794C17.2696 32.0261 17.2696 38.9112 21.5163 43.1578L22.6758 44.3174"
						stroke="white"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<g opacity="0.4">
						<path
							d="M51.8942 48.1378L57.644 42.7004C61.6812 38.6632 61.6812 32.1178 57.644 28.0806C53.6068 24.0434 47.0614 24.0434 43.0242 28.0806L34.8815 35.9918C33.5107 37.3182 33.4927 39.5103 34.8415 40.859V40.8591C36.1746 42.1922 38.3362 42.1922 39.6693 40.8591L41.127 39.4014C41.6877 38.8407 42.597 38.8407 43.1578 39.4014L52.2074 48.4511C53.3033 49.5469 53.3033 51.3235 52.2074 52.4193C51.1117 53.5152 49.3351 53.5152 48.2393 52.4193"
							stroke="white"
							strokeWidth="2.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M30.1175 58.7191L30.1564 58.7579C31.3541 59.9557 33.2961 59.9557 34.4938 58.7579L36.0631 57.1886C37.2609 55.9909 37.2609 54.0489 36.0631 52.8512L36.0243 52.8124C34.8265 51.6146 32.8847 51.6146 31.6869 52.8124L30.1175 54.3817C28.9198 55.5794 28.9198 57.5214 30.1175 58.7191Z"
							stroke="white"
							strokeWidth="2.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M25.6746 54.4095L25.7135 54.4483C26.9113 55.6461 28.8531 55.6461 30.0508 54.4483L34.008 50.4913C35.2057 49.2936 35.2057 47.3516 34.008 46.1539L33.969 46.1151C32.7714 44.9173 30.8294 44.9173 29.6317 46.1151L25.6746 50.0721C24.4769 51.2699 24.4769 53.2118 25.6746 54.4095Z"
							stroke="white"
							strokeWidth="2.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M21.2974 50.0335L21.3363 50.0724C22.5341 51.2701 24.476 51.2701 25.6737 50.0724L28.0945 47.6515C29.2923 46.4538 29.2923 44.512 28.0945 43.3142L28.0557 43.2753C26.8579 42.0776 24.9161 42.0776 23.7183 43.2753L21.2974 45.6962C20.0997 46.8939 20.0997 48.8358 21.2974 50.0335Z"
							stroke="white"
							strokeWidth="2.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
					<path
						d="M36.0171 57.2435L39.5698 60.7963C40.7465 61.9729 42.6542 61.9729 43.8308 60.7963C45.0075 59.6196 45.0075 57.7118 43.8308 56.5352"
						stroke="white"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_390_58137">
					<rect
						width="45"
						height="45"
						fill="white"
						transform="translate(17 18.7617)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
export default SupportIcon;
